import React from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LoadingButton from '@mui/lab/LoadingButton';
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from 'react-redux';
import { setShowChangePassword } from '../../store/user/userSlice';
import { setSnackBar } from '../../store/common/commonSlice';

const ChangePassword = (props) => {
    const {change_password,handleChangePassword,open} = props;
    const { show_change_password,forgot_password_is_loading} = useSelector((state) => state.user);
    const dispatch = useDispatch();
    
    const handleChange = () => {
        formik.resetForm();
        handleChangePassword(!open);
        if (!open === false){
            let reset_change_password = {
                old_password : false,
                password : false,
                confirm_password: false
            }
            dispatch(setShowChangePassword(reset_change_password));
        }
    }

    let PASSWORD_REGX = /^(?=.*[\d])(?=.*[A-Z])(?=.*[a-z])(?=.*[@#$!%*?&])[\w\d@#$!%*?&]{8,16}$/;
    const validationSchema = yup.object().shape({
        old_password: yup.string().required('Old password is required'),
        new_password: yup.string().matches(PASSWORD_REGX, "Passwords do not match: 8-16 Chars, small, caps, special chars and number").required('Password is required'),
        confirm_password: yup.string().required('Re-enter Password is required'),
    });

    const handlePassword = (name) => {
        let newValue = name === 'old_password' ? show_change_password.old_password : 
                        name === 'password' ? show_change_password.password : show_change_password.confirm_password;
        let payload = {[name]:!newValue};
        dispatch(setShowChangePassword(payload));
    }

    const onSubmit = async (values) => {
        if (values.new_password !== values.confirm_password){
            dispatch(setSnackBar({
                open: true,
                message: "Password and Re-enter Password does not match.",
                severity: "error",
            }));
        }
        else {
            let res = await change_password(values);
            if (!res.error){
                formik.resetForm();
                handleChangePassword(!open);
            }
        }
    };

    const formik = useFormik({
        enableReinitialize : true,
        initialValues : {
            old_password : "",
            new_password : "",
            confirm_password: "",
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSubmit(values);
        },
    })
    return (
        <React.Fragment>
        <Dialog
            open={open}
            onClose={handleChange}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth='xs'
            component='form'
            onSubmit={formik.handleSubmit}
        >
            <DialogTitle id="alert-dialog-title">
            {"Change Password"}
            </DialogTitle>
            <DialogContent sx={{
                '& .MuiTextField-root': {
                    my:0.8
                }
            }}>
            <TextField 
                id="old_password" 
                label="Old Password" 
                variant="outlined"
                type={show_change_password.old_password ? 'text' : 'password'}
                size='small' 
                fullWidth
                slotProps={{
                    input : {
                        endAdornment : (
                            <InputAdornment
                                position="end"
                                onClick={() => handlePassword('old_password')}
                                sx={{cursor : "pointer"}}
                            >
                                {show_change_password.old_password ? <VisibilityOff /> : <Visibility />}
                            </InputAdornment>
                        )
                    }
                }}
                name="old_password"
                value={formik.values.old_password}
                onChange={formik.handleChange("old_password")}
                onBlur={formik.handleBlur("old_password")}
                error={
                    formik.touched.old_password && Boolean(formik.errors.old_password)
                }
                helperText={formik.touched.old_password && formik.errors.old_password}
            />
            <TextField 
                id="new_password" 
                label="Password" 
                variant="outlined"
                type={show_change_password.password ? 'text' : 'password'}
                size='small' 
                fullWidth
                slotProps={{
                    input : {
                        endAdornment : (
                            <InputAdornment
                                position="end"
                                onClick={() => handlePassword('password')}
                                sx={{cursor : "pointer"}}
                            >
                                {show_change_password.password ? <VisibilityOff /> : <Visibility />}
                            </InputAdornment>
                        )
                    }
                }}
                name="new_password"
                value={formik.values.new_password}
                onChange={formik.handleChange("new_password")}
                onBlur={formik.handleBlur("new_password")}
                error={
                    formik.touched.new_password && Boolean(formik.errors.new_password)
                }
                helperText={formik.touched.new_password && formik.errors.new_password}
            />
            <TextField 
                id="confirm_password" 
                label="Re-enter Password" 
                variant="outlined"
                type={show_change_password.confirm_password ? 'text' : 'password'}
                size='small' 
                fullWidth
                slotProps={{
                    input : {
                        endAdornment : (
                            <InputAdornment
                                position="end"
                                onClick={() => handlePassword('confirm_password')}
                                sx={{cursor : "pointer"}}
                            >
                                {show_change_password.confirm_password ? <VisibilityOff /> : <Visibility />}
                            </InputAdornment>
                        )
                    }
                }}
                name="confirm_password"
                value={formik.values.confirm_password}
                onChange={formik.handleChange("confirm_password")}
                onBlur={formik.handleBlur("confirm_password")}
                error={
                    formik.touched.confirm_password && Boolean(formik.errors.confirm_password)
                }
                helperText={formik.touched.confirm_password && formik.errors.confirm_password}
            />

            </DialogContent>
            <DialogActions sx={{px:2.5,pb:2}}>
                <Button variant='outlined' color='error' onClick={handleChange} sx={{mr:0.8}}>Cancel</Button>
                <LoadingButton
                    type='submit'
                    loading={forgot_password_is_loading}
                    variant="contained"
                    disableElevation
                >
                    <span>Submit</span>
                </LoadingButton>
                {/* <Button type='submit' variant='contained'>
                    Submit
                </Button> */}
            </DialogActions>
        </Dialog>
        </React.Fragment>
    )
}

export default ChangePassword
